function debounce(func){
  var timer;
  return function(event){
    if(timer) clearTimeout(timer);
    timer = setTimeout(func,100,event);
  };
}

$(function() {
  var size = $(window).width();
  if(size<767) {
    $('#sidebarDash .custom-menu .btn i').removeClass('fa-chevron-circle-left').addClass('fa-chevron-circle-right');
  }
});

jQuery(document).ready(function($){
	//if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
	var MqL = 767;

    var $L = 1200,
    $menu_navigation = $('#main-nav'),
    $cart_trigger = $('#cd-cart-trigger'),
    $hamburger_icon = $('#cd-hamburger-menu'),
    $lateral_cart = $('#cd-cart'),
    $shadow_layer = $('#cd-shadow-layer');

    //open lateral menu on mobile
  	$hamburger_icon.on('click', function(event){
  		event.preventDefault();
  		//close cart panel (if it's open)
  		$lateral_cart.removeClass('speed-in');
  		toggle_panel_visibility($menu_navigation, $shadow_layer, $('body'));
  	});

  	//open cart
  	$cart_trigger.on('click', function(event){
  		event.preventDefault();
  		//close lateral menu (if it's open)
  		$menu_navigation.removeClass('speed-in');
  		toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
  	});

  	//close lateral cart or lateral menu
  	$shadow_layer.on('click', function(){
  		$shadow_layer.removeClass('is-visible');
  		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
  		if( $lateral_cart.hasClass('speed-in') ) {
  			$lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
  				$('body').removeClass('overflow-hidden');
  			});
  			$menu_navigation.removeClass('speed-in');
  		} else {
  			$menu_navigation.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
  				$('body').removeClass('overflow-hidden');
  			});
  			$lateral_cart.removeClass('speed-in');
  		}
  	});

  	//move #main-navigation inside header on laptop
  	//insert #main-navigation after header on mobile
  	move_navigation( $menu_navigation, $L);

  	window.addEventListener("resize",debounce(function(e){
  		move_navigation( $menu_navigation, $L);

  		if( $(window).width() >= $L && $menu_navigation.hasClass('speed-in')) {
  			$menu_navigation.removeClass('speed-in');
  			$shadow_layer.removeClass('is-visible');
  			$('body').removeClass('overflow-hidden');
  		}

  	}));

	//QUI----move nav element position according to window width
moveNavigation();
//	$(window).on('resize', function(){
//		moveNavigation();
//	});
var desktop = checkWindowWidth();
var el = $(".cd-nav-trigger").is(':visible');

    window.addEventListener("resize",debounce(function(e){
            moveNavigation();
            desktop = checkWindowWidth();
            el = $(".cd-nav-trigger").is(':visible');
    }));

	//mobile - open lateral menu clicking on the menu icon
	$('.cd-nav-trigger').on('click', function(event){
		event.preventDefault();
		if( $('.cd-main-content').hasClass('nav-is-visible') ) {
			closeNav();
			$('.cd-overlay').removeClass('is-visible');
		} else {
			$(this).addClass('nav-is-visible');
			$('.cd-primary-nav').addClass('nav-is-visible');
			$('.cd-main-header').addClass('nav-is-visible');
			$('.cd-main-content').addClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				$('body').addClass('overflow-hidden');
			});
			// toggleSearch('close');
			$('.cd-overlay').addClass('is-visible');
		}
	});

	//close lateral menu on mobile
	$('.cd-overlay').on('swiperight', function(){
		if($('.cd-primary-nav').hasClass('nav-is-visible')) {
			closeNav();
			$('.cd-overlay').removeClass('is-visible');
		}
	});
	$('.nav-on-left .cd-overlay').on('swipeleft', function(){
		if($('.cd-primary-nav').hasClass('nav-is-visible')) {
			closeNav();
			$('.cd-overlay').removeClass('is-visible');
		}
	});
	$('.cd-overlay').on('click', function(){
		closeNav();
		$('.cd-overlay').removeClass('is-visible');
	});
	//submenu items - go back link
	$('.go-back').on('click', function(){
		$(this).parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('moves-out');
	});

  function closeNav() {
		$('.cd-nav-trigger').removeClass('nav-is-visible');
		$('.cd-main-header').removeClass('nav-is-visible');
		$('.cd-primary-nav').removeClass('nav-is-visible');
		$('.has-children ul').addClass('is-hidden');
		$('.has-children a').removeClass('selected');
		$('.moves-out').removeClass('moves-out');
		$('.cd-main-content').removeClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$('body').removeClass('overflow-hidden');
		});
	}

    function checkWindowWidth() {
        //check window width (scrollbar included)
        var e = window,
        a = 'inner';
        if (!('innerWidth' in window )) {
               a = 'client';
               e = document.documentElement || document.body;
        }
        if ( e[ a+'Width' ] >= MqL ) {
                    return true;
        } else {
                    return false;
        }
    }

    function moveNavigation(){

        var navigation = $('.cd-nav');
        var desktop = checkWindowWidth();
        var el = $(".cd-nav-trigger").is(':visible');
        if ( desktop && !el ) {
            navigation.detach();
            navigation.insertBefore('.cd-header-buttons');
        } else {
            //open submenu
            $('.has-children').children('a').unbind('mouseover');
            navigation.detach();
            navigation.insertAfter('.cd-main-content');
        }
     }

    $('.has-children').children('a').on('click', function(event){
        if( !checkWindowWidth() ){ event.preventDefault(); }
        var selected = $(this);
        desktop = checkWindowWidth();
        if ( !(desktop && !el) ) {

                    if( selected.next('ul').hasClass('is-hidden') ) {
                      //desktop version only
                      selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
                      selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
                      $('.cd-overlay').addClass('is-visible');
                    } else {
                      selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
                      $('.cd-overlay').removeClass('is-visible');
                    }
       }
    });

    $("body").on("mouseover",".has-children a",function(event){


        var selected = $(this);
        desktop = checkWindowWidth();
        if ( desktop && !el ) {
                if( selected.next('ul').hasClass('is-hidden') ) {
                  //desktop version only
                  selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
                  selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
                  $('.cd-overlay').addClass('is-visible');

                  $('.content').mouseover(function(event){
                    selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
                    $('.cd-overlay').removeClass('is-visible');
                  });

                  $('.cd-main-header').one('click', function(event){
                    selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
                    $('.cd-overlay').removeClass('is-visible');
                  });

                } else {
                  selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
                  $('.cd-overlay').removeClass('is-visible');
                }

         }
      });
});

$('.no-children').mouseover(function(event){
  $('.cd-secondary-nav').addClass('is-hidden');
  $('.cd-nav-gallery').addClass('is-hidden');
});


function toggle_panel_visibility ($lateral_panel, $background_layer, $body) {
	if( $lateral_panel.hasClass('speed-in') ) {
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		$lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$body.removeClass('overflow-hidden');
		});
		$background_layer.removeClass('is-visible');

	} else {
		$lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$body.addClass('overflow-hidden');
		});
		$background_layer.addClass('is-visible');
	}
}

$('#sidebarCollapse').on('click', function () {
    $('#sidebarDash').toggleClass('active');

    var size = $(window).width();
    if(size<767) {
      $(this).find('i').toggleClass('fa-chevron-circle-right fa-chevron-circle-left');
      $('#contentDash').toggleClass('scuris');
    } else {
      $(this).find('i').toggleClass('fa-chevron-circle-left fa-chevron-circle-right');
    }
    $('.custom-menu .btn').toggleClass('attivo');

});

function move_navigation( $navigation, $MQ) {
	if ( $(window).width() >= $MQ ) {
		$navigation.detach();
		$navigation.appendTo('header');
	} else {
		$navigation.detach();
		$navigation.insertAfter('header');
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/navigation.js